import { COLORS, FONTS, SURFACE_GRADIENTS } from '@imobdesk/design-tokens'

const fontSans = FONTS.find((f) => f.id === 'sans')!
const fontHeading = FONTS.find((f) => f.id === 'heading')!
const slate600 = COLORS.find((c) => c.id === 'slate-600')!
const radialHeroGlow = SURFACE_GRADIENTS.find((s) => s.id === 'radial-hero-glow')!

/** Superfície do fluxo público (contratação / handoff / sucesso). */
export const publicFlowSurfaceClass =
  `min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50/30 to-violet-50/40 antialiased ${fontSans.tailwind} text-slate-900 selection:bg-indigo-600/20 selection:text-indigo-900`

/** Títulos — Plus Jakarta Sans (`FONTS` id heading). */
export const publicFlowHeadingClass =
  `${fontHeading.tailwind} font-bold tracking-tight text-slate-900`

/** Subtítulos — `COLORS` slate-600. */
export const publicFlowSubtitleClass = `${slate600.tailwind} font-medium`

/** `SURFACE_GRADIENTS.radial-hero-glow` — camada radial no topo do shell público. */
export const publicFlowRadialGlowStyle = {
  background: radialHeroGlow.css,
} as const
